import { Type, type Static } from '@sinclair/typebox';

export const CatalogImpactSampleVoucherSchema = Type.Object({
  voucher_id: Type.Number(),
  unique_code: Type.String(),
  type: Type.String(),
  status: Type.String(),
});
export type CatalogImpactSampleVoucherObject = Static<typeof CatalogImpactSampleVoucherSchema>;

export const CatalogVoucherImpactResponseSchema = Type.Object({
  has_open_vouchers: Type.Boolean(),
  open_voucher_count: Type.Number(),
  sample_vouchers: Type.Array(CatalogImpactSampleVoucherSchema),
});
export type CatalogVoucherImpactResponseObject = Static<typeof CatalogVoucherImpactResponseSchema>;

/**
 * Résultat d'une resynchronisation des bons ouverts après modification d'un élément
 * du catalogue. `synced_count` = nombre de bons dont le snapshot (nom/couleur/version)
 * a été rafraîchi ; `manual_count` = nombre d'items dont la durée vendue n'existe plus
 * dans la config courante et nécessite donc un traitement manuel.
 */
export const SyncVouchersResponseSchema = Type.Object({
  synced_count: Type.Number(),
  manual_count: Type.Number(),
});
export type SyncVouchersResponseObject = Static<typeof SyncVouchersResponseSchema>;
